"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = exports.UserLoginStatus = exports.UserGender = exports.UserAgeCategory = void 0;
/**
 * Enum für den Parameter user_age_category
 */
var UserAgeCategory;
(function (UserAgeCategory) {
    UserAgeCategory["UNDER_28"] = "young";
    UserAgeCategory["STANDARD"] = "standard";
})(UserAgeCategory || (exports.UserAgeCategory = UserAgeCategory = {}));
/**
 * Enum für den Parameter user_gender
 */
var UserGender;
(function (UserGender) {
    UserGender["MALE"] = "1";
    UserGender["FEMALE"] = "2";
    UserGender["DIVERSE"] = "3";
})(UserGender || (exports.UserGender = UserGender = {}));
/**
 * Enum für den Parameter user_login_status
 */
var UserLoginStatus;
(function (UserLoginStatus) {
    UserLoginStatus["LOGGED_IN"] = "eingeloggt";
    UserLoginStatus["NOT_LOGGED_IN"] = "nicht-eingeloggt";
})(UserLoginStatus || (exports.UserLoginStatus = UserLoginStatus = {}));
/**
 * Enum für den Parameter user_type
 */
var UserType;
(function (UserType) {
    UserType["NEW_CUSTOMER"] = "nicht-bestandskunde";
    UserType["EXISTING_CUSTOMER"] = "bestandskunde";
})(UserType || (exports.UserType = UserType = {}));
